module.exports = __webpack_public_path__ + "img/sidebar-collapse.c60bf019.svg";